import * as yup from 'yup';
import { notFutureDate } from 'utils/yupExtensions';

export const followUpValidation = yup.object().shape({
  followUpDate: notFutureDate().required('Follow Up date is required'),
  trainerId: yup
    .number()
    .nullable()
    .default(null)
    .when('isFromIdp', {
      is: (isFromIdp: boolean) => !isFromIdp,
      then: (schema) => schema.required('Trainer is required'),
    }),
  idpTrainer: yup
    .string()
    .nullable()
    .default(null)
    .max(250, 'Trainer name cannot exceed 250 characters')
    .when('isFromIdp', {
      is: (isFromIdp: boolean) => isFromIdp,
      then: (schema) => schema.required('Trainer is required'),
    }),
  isFromIdp: yup.boolean().required(),
});

export type FollowUpFormData = yup.InferType<typeof followUpValidation>;
